const WEBTREKK_LOAD_SUCCESS_EVENT = 'WEBTREKK_LOAD_SUCCESS';
const WEBTREKK_LOAD_FAILURE_EVENT = 'WEBTREKK_LOAD_FAILURE';
const WEBTREKK_REFERRER_COOKİE_NAME = 'wt_ref';

const WEBTREKK_CONSTANTS = {
  CONTENT_ID: 'Mobile-SpeedCart-Category',
  SITE: 'Mobile',
  LOGIN: 'Login',
  NOT_LOGIN: 'Not Login',
  IN_ACTIVE: 'Inactive',
  ACTIVE: 'Active',
  ADD_TO_CART_TYPE: '_SpeedCart',
  PRODUCT_STATUS: 'add',
  PRODUCT_QUANTITY: '1',
  CUSTOM_SESSION_AUTH_TYPE_KEY: 4,
  CONTENT_GROUP_SITE_TYPE_KEY: 1,
  CONTENT_GROUP_ADD_TO_CART_TYPE_KEY: 2,
  CONTENT_GROUP_PAGE_TYPE: 3,
  CONTENT_GROUP_PAGE_URL: 4,
  CUSTOM_PARAM_CATEGORY_HIERARCHY_KEY: 11,
  CUSTOM_PARAM_CATEGORY_STATUS_KEY: 13,
  CUSTOM_PARAM_ADD_TO_CART_CATEGORY_HIERARCHY: 16,
  CUSTOM_PARAM_ADD_TO_CART_PLACEMENT: 17,
  CUSTOM_PARAM_ADD_TO_CART_MERCHANT_NAME: 18,
  CUSTOM_PARAM_ADD_TO_CART_MERCHANT_ID: 19,
};

const WEBTREKK_CATEGORY_PAGE_CONSTANTS = {
  CONTENT_ID: 'Mobile-SpeedCart-Category',
  SITE: 'Mobile',
  CATEGORY: 'Category',
  CATEGORY_PAGE: 'CategoryPage',
  LOGIN: 'Login',
  NOT_LOGIN: 'Not Login',
  IN_ACTIVE: 'Inactive',
  ACTIVE: 'Active',
  ADD_TO_CART_TYPE: '_SpeedCart',
  PRODUCT_STATUS: 'add',
  PRODUCT_QUANTITY: '1',
  CUSTOM_SESSION_AUTH_TYPE_KEY: 4,
  CONTENT_GROUP_SITE_TYPE_KEY: 1,
  CONTENT_GROUP_CATEGORY_PAGE_TYPE: 2,
  CONTENT_GROUP_CATEGORY_KEY: 3,
  CONTENT_GROUP_CATEGORY_NAME_KEY: 4,
  CUSTOM_PARAM_CATEGORY_HIERARCHY_KEY: 11,
  CUSTOM_PARAM_CATEGORY_STATUS_KEY: 13,
};

const WEBTREKK_SEARCH_PAGE_CONSTANTS = {
  CONTENT_ID: 'Mobile-SpeedCart-Search',
  SITE: 'Mobile',
  SEARCH: 'Search',
  SEARCH_PAGE: 'SearchPage',
  LOGIN: 'Login',
  NOT_LOGIN: 'Not Login',
  CUSTOM_SESSION_AUTH_TYPE_KEY: 4,
  CONTENT_GROUP_SITE_TYPE_KEY: 1,
  CONTENT_GROUP_SEARCH_PAGE_TYPE: 2,
  CONTENT_GROUP_SEARCH_KEY: 3,
  CONTENT_GROUP_SEARCH_NAME_KEY: 4,
  CUSTOM_PARAM_TOTAL_SEARCH_COUNT: 2,
  CUSTOM_PARAM_TOTAL_SEARCH_PAGE_COUNT: 6,
  CUSTOM_PARAM_CATEGORY_HIERARCHY_KEY: 11,
};

const WEBTREKK_TAG_PAGE_CONSTANTS = {
  CONTENT_ID: 'Mobile-SpeedCart-TagPage',
  SITE: 'Mobile',
  TAG: 'Tag',
  TAG_PAGE: 'TagPage',
  LOGIN: 'Login',
  NOT_LOGIN: 'Not Login',
  CUSTOM_SESSION_AUTH_TYPE_KEY: 4,
  CONTENT_GROUP_SITE_TYPE_KEY: 1,
  CONTENT_GROUP_TAG_PAGE_TYPE: 2,
  CONTENT_GROUP_TAG_KEY: 3,
  CONTENT_GROUP_TAG_NAME_KEY: 4,
  CUSTOM_PARAM_TOTAL_SEARCH_COUNT: 2,
  CUSTOM_PARAM_TOTAL_SEARCH_PAGE_COUNT: 6,
  CUSTOM_PARAM_TAG_HIERARCHY_KEY: 11,
  CUSTOM_PARAM_CATEGORY_HIERARCHY_KEY: 11,
};

const WEBTREKK_BRAND_PAGE_CONSTANTS = {
  CONTENT_ID: 'Mobile-BrandPage',
  SITE: 'Mobile',
  BRAND: 'BRAND',
  BRAND_PAGE: '_Markalar',
  LOGIN: 'Login',
  NOT_LOGIN: 'Not Login',
  CUSTOM_SESSION_AUTH_TYPE_KEY: 4,
  CONTENT_GROUP_SITE_TYPE_KEY: 1,
  CONTENT_GROUP_BRAND_PAGE_TYPE: 2,
  CONTENT_GROUP_BRAND_KEY: 3,
  CONTENT_GROUP_BRAND_NAME_KEY: 4,
  CUSTOM_PARAM_TOTAL_BRAND_COUNT: 2,
  CUSTOM_PARAM_TOTAL_BRAND_PAGE_COUNT: 6,
  CUSTOM_PARAM_BRAND_HIERARCHY_KEY: 11,
  CUSTOM_PARAM_CATEGORY_HIERARCHY_KEY: 11,
};

const WEBTREKK_MERCHANT_DESKTOP_PAGE_CONSTANTS = {
  CONTENT_ID: 'Desktop-MerchantPage',
  SITE: 'Storefront',
  MERCHANT: 'Merchant',
  MERCHANT_PAGE: 'MerchantPage',
  LOGIN: 'Login',
  NOT_LOGIN: 'Not Login',
  CONTENT_GROUP_SITE_TYPE_KEY: 1,
  CONTENT_GROUP_MERCHANT_PAGE_TYPE: 3,
  CONTENT_GROUP_MERCHANT_KEY: 2,
  CONTENT_GROUP_MERCHANT_NAME_KEY: 4,
  CUSTOM_SESSION_AUTH_TYPE_KEY: 4,
  CUSTOM_PARAM_TOTAL_SEARCH_COUNT: 2,
  CUSTOM_PARAM_TOTAL_SEARCH_PAGE_COUNT: 6,
  CUSTOM_PARAM_TAG_HIERARCHY_KEY: 11,
  CUSTOM_PARAM_CATEGORY_HIERARCHY_KEY: 11,
};

const WEBTREKK_BRAND_PAGE_DESKTOP_CONSTANTS = {
  CONTENT_ID: 'Desktop-BrandPage',
  SITE: 'Storefront',
  BRAND: 'Brand',
  BRAND_PAGE: 'BrandPage',
  LOGIN: 'Login',
  NOT_LOGIN: 'Not Login',
  CUSTOM_SESSION_AUTH_TYPE_KEY: 4,
  CONTENT_GROUP_SITE_TYPE_KEY: 1,
  CONTENT_GROUP_BRAND_PAGE_TYPE: 2,
  CONTENT_GROUP_BRAND_KEY: 3,
  CONTENT_GROUP_BRAND_NAME_KEY: 4,
  CUSTOM_PARAM_TOTAL_BRAND_COUNT: 2,
  CUSTOM_PARAM_TOTAL_BRAND_PAGE_COUNT: 6,
  CUSTOM_PARAM_BRAND_HIERARCHY_KEY: 11,
  CUSTOM_PARAM_CATEGORY_HIERARCHY_KEY: 11,
};

const WEBTREKK_TAG_PAGE_DESKTOP_CONSTANTS = {
  CONTENT_ID: 'Desktop-SpeedCart-TagPage',
  SITE: 'Storefront',
  TAG: 'Tag',
  TAG_PAGE: 'TagPage',
  LOGIN: 'Login',
  NOT_LOGIN: 'Not Login',
  CONTENT_GROUP_SITE_TYPE_KEY: 1,
  CONTENT_GROUP_TAG_PAGE_TYPE: 2,
  CONTENT_GROUP_TAG_KEY: 3,
  CONTENT_GROUP_TAG_NAME_KEY: 4,
  CUSTOM_SESSION_AUTH_TYPE_KEY: 4,
  CUSTOM_PARAM_TOTAL_SEARCH_COUNT: 2,
  CUSTOM_PARAM_TOTAL_SEARCH_PAGE_COUNT: 6,
  CUSTOM_PARAM_TAG_HIERARCHY_KEY: 11,
  CUSTOM_PARAM_CATEGORY_HIERARCHY_KEY: 11,
};

export {
  WEBTREKK_CONSTANTS,
  WEBTREKK_CATEGORY_PAGE_CONSTANTS,
  WEBTREKK_SEARCH_PAGE_CONSTANTS,
  WEBTREKK_TAG_PAGE_CONSTANTS,
  WEBTREKK_LOAD_SUCCESS_EVENT,
  WEBTREKK_LOAD_FAILURE_EVENT,
  WEBTREKK_REFERRER_COOKİE_NAME,
  WEBTREKK_BRAND_PAGE_CONSTANTS,
  WEBTREKK_BRAND_PAGE_DESKTOP_CONSTANTS,
  WEBTREKK_TAG_PAGE_DESKTOP_CONSTANTS,
  WEBTREKK_MERCHANT_DESKTOP_PAGE_CONSTANTS
}
